import React, { useContext, useState, useEffect } from "react";
import { __t } from "@core/translation/translation";
import { Grid, Tooltip, withStyles } from "@material-ui/core";
import Typography from "@components/Typography";
import PriceFormat from "@components/PriceFormat";
import { getMarketPairDisplay } from "@core/utils/getCurrencyMeta";
import { MarketContext } from "@context/MarketContext";

const MUITooltip = withStyles((theme) => ({
  tooltip: {
    display: "flex",
    flexDirection: "column",
    width: theme.spacing(90),
    height: theme.spacing(36),
    padding: theme.spacing(3),
    borderRadius: theme.spacing(2),
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.secondary.main
        : theme.palette.secondary.tint60,
    color: theme.palette.white.qrCode,
  },
  tooltipPlacementLeft: {
    transformOrigin: "right center",
    margin: "0px !important",
  },
}))(Tooltip);

const CustomItemTooltip = (props) => {
  const { items, hoverIndex, type, currencyName, children, activeCal } = props;
  const { baseName, quoteName, baseUnit, quoteUnit } =
    getMarketPairDisplay(currencyName);
  const FirstCurrencyName = baseName;
  const SecondCurrencyName = quoteName;
  const FirstCurrencyUnit = baseUnit;
  const SecondCurrencyUnit = quoteUnit;
  const market = useContext(MarketContext);

  const [state, setState] = useState({
    unitPrice: 0,
    size: 0,
    total: 0,
  });
  const tooltipItems = [
    {
      name: __t("Price"),
      unit: SecondCurrencyName,
      value: "unitPrice",
      toFix: market.SecondCurrencyScale(SecondCurrencyUnit),
    },
    {
      name: __t("currency amount"),
      unit: FirstCurrencyName,
      value: "size",
      toFix: market.FirstCurrencyScale(FirstCurrencyUnit),
    },
    {
      name: __t("Total"),
      unit: SecondCurrencyName,
      value: "total",
      toFix: market.SecondCurrencyScale(SecondCurrencyUnit),
    },
  ];

  const getAverege = (index, name, toFix) => {
    if (activeCal) {
      switch (name) {
        case "unitPrice": {
          return items[index - 1][name];
        }
        case "size": {
          let sum = 0;
          for (let i = 0; i < index; i++) {
            sum += items[i][name];
          }
          return sum.toFixed(toFix);
        }
        case "total": {
          let sum = 0;
          for (let i = 0; i < index; i++) {
            sum += items[i].unitPrice * items[i].size;
          }
          return sum.toFixed(toFix);
        }
      }
    }
  };

  return (
    <MUITooltip
      interactive
      title={
        <Grid container>
          <Grid
            item
            container
            direction="column"
            justify="space-between"
            spacing={4}
          >
            {tooltipItems?.map((tooltipItem) => (
              <Grid
                item
                container
                direction="row-reverse"
                justify="space-between"
              >
                <Grid item>
                  <Typography variant="3xs" isBold>
                    {tooltipItem.name}
                  </Typography>
                  <Typography variant="3xs" color="secondary.tint100">
                    {" "}
                    ({tooltipItem.unit})
                  </Typography>
                </Grid>
                <Grid item>
                  <PriceFormat
                    price={getAverege(
                      hoverIndex,
                      tooltipItem.value,
                      tooltipItem.toFix
                    )}
                  />
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
      }
      placement="right"
      arrow="true"
    >
      {children}
    </MUITooltip>
  );
};

export default CustomItemTooltip;
